import o from "./index86.mjs";
import i from "./index108.mjs";
function f(t) {
  var r = i(t, "string");
  return o(r) == "symbol" ? r : r + "";
}
export {
  f as default
};
